module.exports = __webpack_public_path__ + "static/media/instagram.538d0728.jpg";